import {get, set, isFunction} from "lodash"

export default function setIfNotSet(obj: any, key: string, value: any) {
  if (get(obj, key, null) === null) {
    if (isFunction(value)) {
      set(obj, key, value())
    } else {
      set(obj, key, value)
    }
  }
}
